var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._l((_vm.matchReasons),function(reason,index){return _c('Reason',{key:index,attrs:{"compressed":_vm.compressed,"item-type":_vm.rowType,"reason":reason,"image-column":_vm.imageColumn,"story":_vm.story,"clickable":_vm.clickable,"emit":"reasonclicked"},on:{"reasonclicked":_vm.reasonClicked}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }